import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AttachmentService } from 'src/app/service/attachment.service';
import { FreeFormAgendaService } from 'src/app/service/free-form-agenda.service';
import { FreeFormMinutesService } from 'src/app/service/free-form-minutes.service';
import { AddLinkDialogComponent } from '../add-link-dialog/add-link-dialog.component';
import { MeetingService } from 'src/app/service/meeting.service';
import { AgendaTaskEditDialogComponent } from '../agenda-task-edit-dialog/agenda-task-edit-dialog.component';
import { AttachmentDialogComponent } from '../attachment-dialog/attachment-dialog.component';
import { Globals } from 'src/app/service/global';
import { BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout';
import { forkJoin, Observable, of } from 'rxjs';
import { SideNavServiceService } from 'src/app/service/side-nav-service.service';
import { PermissionService } from 'src/app/service/permission.service';
import { UtilityService } from 'src/app/service/utility.service';
declare var CKEDITOR: any;
import { environment_const, environment_msg, meetingTourValues, scheduleMeetingTourValues } from 'src/environments/environment';
import { MatMenuTrigger } from '@angular/material/menu';
import { TuleapDialogComponent } from '../tuleap-dialog/tuleap-dialog.component';
import { LoginService } from 'src/app/service/login.service';
import { NotifierService } from 'angular-notifier';
import { MinutesCollabDetails } from 'src/app/models/basicMeetingModel';
import { DatePipe } from '@angular/common';
import { CK5_EDITOR, buildCk5Config, CK5_READONLY_CONFIG, setupCk5UploadAdapter, CK5_TOOLBAR } from 'src/app/config/ck5-common';
import Quill from 'quill';
import { setupQuillUploadAdapter } from 'src/app/config/quill-common';
import { quillSharedToolbar } from 'src/app/config/quill-shared-toolbar';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { UtcDatePipe } from 'src/app/pipe/UtcDate.pipe';
import { HistoryComponent } from '../history/history.component';
import { HistoryDialogService } from 'src/app/service/history-dialog.service';
import { LinkNotetotaskDialogComponent } from '../link-notetotask-dialog/link-notetotask-dialog.component';
import { AttendeeService } from 'src/app/service/attendee.service';
import { AnyCnameRecord } from 'dns';
export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'MMM DD, yyyy',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY',
  },
};



const Inline = Quill.import('blots/inline') as any;

class MentionBlot extends Inline {
  static blotName = 'mention';
  static tagName = 'span';
  static className = 'custom-mention';

  static create(value: any) {
    const node = super.create();

    node.setAttribute('contenteditable', 'false');
    node.setAttribute('data-id', value.id);
    node.innerText = '@' + value.name;

    return node;
  }

  static formats(node: HTMLElement) {
    return {
      id: node.getAttribute('data-id')
    };
  }
}

Quill.register(MentionBlot, true);




@Component({
  selector: 'app-instant-meeting-task',
  templateUrl: './instant-meeting-task.component.html',
  styleUrls: [
    './instant-meeting-task.component.css',
    '../../../assets/adc-styles/ckeditor-agenda-custom.css'
  ],
  providers: [{ provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },

  { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
    , DatePipe, UtcDatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InstantMeetingTaskComponent implements OnInit, AfterViewInit {
  //UI Team variable declaration

  collabVariable = 'active'
  disaleAttachmentFileIcon: any;
  @Input() hideParts: any
  showTuleapIcon = true
  disabelTuleapBtn: any;
  enableTuleapTaskAdded: any = true;
  @Input()
  deviceXs!: boolean;

  @Input()
  deviceSm!: boolean;

  @Input()
  deviceMd!: boolean;

  @Input()
  deviceLg!: boolean;

  @Input()
  deviceXl!: boolean;
  meetingTourValues = meetingTourValues
  scheduleMeetingTourValues = scheduleMeetingTourValues;
  //property for adding new class for login user is a task user.
  selectedTabName: any;
  selectedNotesList: any[] = [];

  //padlock variable
  padlock: any;
  matDialogRefs!: MatDialogRef<AttachmentDialogComponent>;
  matDialogRef!: MatDialogRef<AgendaTaskEditDialogComponent>;
  taskStatusList: any;
  taskStatusCode = new UntypedFormControl();
  isPrivate: any;
  showToolTip = false;
  taskCompleted: any;
  agendaAttachResp: any;
  attachCount: boolean = true;
  attachmentCount: any;
  attachmentTotalCnt: any = true;
  attachmentIcon = 'Y';
  @Input() pinDialogTriggered = false;

  @Input() meetingResponse: any
  editCollabData = <MinutesCollabDetails>{};
  padlockDisable: any;
  isExtraSmall: Observable<BreakpointState> = this.breakpointObserver.observe(
    Breakpoints.XSmall
  );
  isMedium: Observable<BreakpointState> = this.breakpointObserver.observe(
    Breakpoints.Medium
  )
  isSmall: Observable<BreakpointState> = this.breakpointObserver.observe(
    Breakpoints.Small
  )
  @Input() videoSectionStatusChecker: any
  disableTaskIcon: any;
  taskStatusIcon: any;
  decryptKey: string = '';
  private readonly notifier!: NotifierService;
  updatedLinkedNoteIds: any;
  updatedLinkedNotes: any;
  toLinkingNotes: any;

  mentionList: any[] = [];
  showDropdown = false;
  mentionIndex: number = 0;
  dropdownPosition = { top: 0, left: 0 };
  activeIndex: number = 0;


  constructor(private datepipe: DatePipe, private loginService: LoginService, private utility: UtilityService, private permissionService: PermissionService, public sideNavService: SideNavServiceService, private readonly breakpointObserver: BreakpointObserver, private globals: Globals, private dialog: MatDialog, public commonMinService: FreeFormMinutesService, private matDialog: MatDialog, public attachService: AttachmentService, public commonAgService: FreeFormAgendaService, private meetingService: MeetingService, public freeFormAgenda: FreeFormAgendaService, private historyDialogService: HistoryDialogService, private utilService: UtilityService, private attendeeService: AttendeeService, public cdr: ChangeDetectorRef) {
    this.taskStatusList = this.globals.globaltaskStatusList;

  }

  private normalizeDueDateSpans(scope: HTMLElement) {
    try {
      // Remove BOM/ZWSP globally in scope
      const walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT, null);
      const nodes: Text[] = [];
      while (walker.nextNode()) nodes.push(walker.currentNode as Text);
      nodes.forEach(t => { if (/[\uFEFF\u200B]/.test(t.data)) t.data = t.data.replace(/[\uFEFF\u200B]/g, ''); });

      const dates = Array.from(scope.querySelectorAll('span.minDateCls')) as HTMLSpanElement[];
      dates.forEach((el) => {
        try {
          // Enforce required root attributes
          el.setAttribute('contenteditable', 'false');
          // Remove any legacy attributes that break click handlers
          el.removeAttribute('code');
          const inner = el.querySelector('span[contenteditable="false"]') as HTMLElement | null;
          if (inner) {
            while (inner.firstChild) el.insertBefore(inner.firstChild, inner);
            inner.remove();
          }
          // Ensure label exists and contains NBSP after colon
          let label = el.querySelector(':scope > span.dueLabelCls') as HTMLSpanElement | null;
          if (!label) {
            label = document.createElement('span');
            label.className = 'dueLabelCls';
            el.insertBefore(label, el.firstChild);
          }
          label.innerHTML = 'Due Date: \u00A0';
        } catch {}
      });
    } catch {}
  }

  // Extract owners and due date info from current editor HTML
  private extractOwnersAndDueDate(html: string): { owners: Array<{ fkSecUserOwner: any, ownerName: string }>, dueDateStr: string } {
    const owners: Array<{ fkSecUserOwner: any, ownerName: string }> = [];
    let dueDateStr = '';
    if (!html) return { owners, dueDateStr };
    try {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const body = doc.body;
      // CKEditor5 mention format
      const mentionNodes = body.querySelectorAll('.mention');
      mentionNodes.forEach((n: Element) => {
        const id = (n.getAttribute('data-id') || n.getAttribute('data-user-id') || '').trim();
        const name = (n.textContent || '').replace(/^@/, '').trim();
        if (id && name) owners.push({ fkSecUserOwner: id, ownerName: name + ' ' });
      });
      // Legacy atwho-inserted (if already present)
      const atwho = body.querySelectorAll('.atwho-inserted');
      atwho.forEach((n: Element) => {
        const id = (n.getAttribute('fkuserid') || n.getAttribute('id') || '').trim();
        // Strip leading/trailing commas and whitespace from name
        const name = (n.textContent || '').replace(/^[,\s]+|[,\s]+$/g, '').trim();
        if (id && name) owners.push({ fkSecUserOwner: id, ownerName: name });
      });
      // Due date: prefer minDateCls if present
      const dateNode = body.querySelector('.minDateCls');
      if (dateNode) {
        const text = (dateNode.textContent || '').trim();
        const m = text.match(/Due Date:\s*([^\n]+)/i);
        if (m) dueDateStr = m[1].trim();
      } else {
        // Fallback: scan text for "Due Date: <date>"
        const fullText = (body.textContent || '').trim();
        const m = fullText.match(/Due Date:\s*([A-Za-z]{3}\s\d{2},\s\d{4})(?:\s.*)?/);
        if (m) dueDateStr = m[1].trim();
      }
    } catch { }
    return { owners, dueDateStr };
  }

  @Input() contentEditableBoolmin: any;
  @Input() minAttrList: any;
  taskDetails: any;
  //@Output() isTaskAddedOrModified : any = new EventEmitter();
  // CKEditor5 shared config
  public Editor: any = CK5_EDITOR;
  private activeEditor: any;
  public ck5Config: any;
  public ck5ReadOnlyConfig: any = {
    toolbar: [],
    table: { contentToolbar: [] }
  };
  private toolbarInteracting: boolean = false;
  private autosaveTimer: any = null;
  private lastSavedHtml: string = '';
  private blurSavingGuard = false;
  taskHtml: any
  // Quill integration state
  private quillInst?: Quill;
  private isActiveEditor: boolean = false;
  private hasUserInteracted: boolean = false;
  public editorConfig: any = {
    enableTable: true,
    letter: false,
    modules: {
      toolbar: {
        container: [
          ['bold','italic','underline','strike'],
          [{ list: 'ordered' }, { list: 'bullet' }],
          [{ indent: '+1' }, { indent: '-1' }],
          [{ color: [] }, { background: [] }],
          ['image','link']
        ],
        handlers: {
          insertheaderorfooter: () => {},
          subreport: () => {},
          preview: () => {},
          print: () => {},
          formula: () => {},
        },
      },
    },
    sharedToolbar: { enabled: true, selectorId: 'quill-shared-toolbar' },
    placeholder: ' ',
    theme: 'snow',
  };

  ngOnInit(): void {
    this.commonMinService.setActivateCkEditor(true);
    var localDate = new Date(this.minAttrList.lastModifiedOn);
    var padLockValue = this.minAttrList.isPrivate;
    if (padLockValue == 'Y') {
      this.padlock = true;
    } else {
      this.padlock = false;
    }
  // Seed noteDescription from DB on init if empty using constructed task section (title, owners, due date)
    this.setCurrentStatusCodeByStatus();
  }
  ngAfterViewInit() {
    if (this.minAttrList.tuleapId == null) {
      this.disabelTuleapBtn = false;
      this.enableTuleapTaskAdded = true;
      if (localStorage.getItem("orgCode") != undefined && (localStorage.getItem("orgCode") == "CHN" || localStorage.getItem("orgCode") == "GGN" || localStorage.getItem("orgCode") == "NY")) {
        this.showTuleapIcon = true;
      } else {
        this.showTuleapIcon = false;
      }
    } else {
      this.disabelTuleapBtn = true;
      this.showTuleapIcon = false;
      this.enableTuleapTaskAdded = false;
    }
    var roleFlag = this.permissionService.checkRoleRightsWithNoAlert(this.utility.featureList.TASK, this.utility.permissionType.MODIFY);

    if (!roleFlag) {
      return;
    } else {
      this.getTaskUserRights();
    }


    // CKEditor5 wrapper manages read-only via template; no manual contenteditable toggles

    this.setCurrentStatusCodeByStatus();
    //code added to allow to make private only for created user
    if (this.minAttrList.createdBy == localStorage.getItem("userId")) {
      this.padlockDisable = false;
    } else {
      this.padlockDisable = true;
    }
    //close

  }

  handleMouseUp(noteElement: HTMLDivElement): void {
    const selection = window.getSelection();
    if (selection && selection.toString()) {
      noteElement.setAttribute('highlightIndex', '0');
    }
  }
  handleFocus(event: FocusEvent, noteElement: HTMLDivElement): void {
    this.sideNavService.closeAllAccordtion();
    this.sideNavService.smootherScroll(event.target);
    noteElement.setAttribute('highlightIndex', '0');
  }

  handleKeyDown(event: KeyboardEvent, noteElement: HTMLDivElement): void {
    // Skip Alt+N/D/T/1/2/3/G shortcuts - they're handled separately in the keydown listener
    const isAltShortcut = event.altKey && (
      event.keyCode === 78 || // N
      event.keyCode === 68 || // D
      event.keyCode === 84 || // T
      event.keyCode === 49 || event.keyCode === 97 || // 1
      event.keyCode === 50 || event.keyCode === 98 || // 2
      event.keyCode === 51 || event.keyCode === 99 || // 3
      event.keyCode === 71    // G
    );
    if (!isAltShortcut) {
      this.commonAgService.trackChangesWhileEditing(
        noteElement.getAttribute('taskId')!,
        noteElement.getAttribute('agId')!,
        event,
        noteElement.getAttribute('entityType')!,
        'agMinId' + noteElement.getAttribute('taskId')
      );
    }
    if (event.ctrlKey && event.shiftKey && event.key.toLowerCase() === 'h') {
      event.preventDefault();
      this.highlightNextText(noteElement);
    }
  }

  highlightNextText(noteElement: HTMLDivElement): void {
    const regex = environment_const.patternKey;
    const content = noteElement.textContent || '';
    const matches = Array.from(content.matchAll(regex));
    const count = matches.length;
    if (count === 0) return;

    let currentIndex = parseInt(noteElement.getAttribute('highlightIndex') || '0', 10);
    noteElement.setAttribute('highlightIndex', ((currentIndex + 1) % count).toString());

    this.applyHighlight(noteElement, matches, currentIndex);
  }

  applyHighlight(noteElement: HTMLDivElement, matches: RegExpMatchArray[], highlightIndex: number): void {
    if (!noteElement.firstChild) return;

    const selection = window.getSelection();
    const range = document.createRange();

    const match = matches[highlightIndex];
    if (!match) return;
    const start = match.index!;
    const end = start + match[0].length;


    let offset = 0;
    let found = false;
    const nodes = Array.from(noteElement.childNodes);
    for (const node of nodes) {
      const nodeLength = node.textContent?.length || 0;

      if (offset + nodeLength >= start && !found) {
        const relativeStart = start - offset;
        const relativeEnd = end - offset;

        range.setStart(node, relativeStart);
        range.setEnd(node, Math.min(relativeEnd, nodeLength));

        found = true;
        break;
      }

      offset += nodeLength;
    }

    if (found) {
      selection?.removeAllRanges();
      selection?.addRange(range);
    }
  }

  ngOnDestroy() {
    // for (var instance in CKEDITOR.instances) {
    //   CKEDITOR.instances[instance].destroy();
    // }
  }

  getMinComStatusCode() {

    if (this.meetingResponse.commonMomStatusCode == 'A') {
      this.disaleAttachmentFileIcon = false;
    }
  }

  setCurrentStatusCodeByStatus() {
    var statusCode = "";
    this.taskStatusList.forEach((data: any) => {
      if (data.codeId == this.minAttrList.status) {
        statusCode = data.code
      }
    });

    this.taskStatusCode.setValue(statusCode)
  }
  getTooltipValue(): string {
    const selectedStatus = this.taskStatusList.find((data: { code: any; }) => data.code === this.taskStatusCode.value);
    return selectedStatus ? selectedStatus.description : 'Task';
  }
  getTaskUserRights() {

    if (this.globals.roleCode == 'TU') {
      this.minAttrList.actionItemOwner.forEach((data: any) => {

        if (data.fkSecUserOwner == this.globals.userId) {

          this.selectedTabName = true;
          this.disableTaskIcon = false;
        } else {
          this.selectedTabName = false;
          this.disableTaskIcon = true;
        }
      });
    }
  }

  statusTracker(id: any, vari: any) {
    if (vari == 'active') {
      let element = (<HTMLElement>document.getElementById("agMinId" + id))
      element.contentEditable = 'false'
    }
    else if (vari == 'inActive') {
      let element = (<HTMLElement>document.getElementById("agMinId" + id))
      element.contentEditable = 'true'
    }
  }

  // used to open task edit dialog box
  taskEditDialog(curTaskUiInfo: any) {
    //
    var taskId = curTaskUiInfo.taskId;
    if (curTaskUiInfo.isFollowUpFlag == 'Y') {
      taskId = curTaskUiInfo.prevMinuteId;
    }
    this.meetingService.fetchTaskInfo(taskId).subscribe(
      (meetingRes: any) => {
        this.taskDetails = meetingRes.body
        this.matDialogRef = this.matDialog.open(AgendaTaskEditDialogComponent, {
          data: { taskData: meetingRes.body, curTaskUiInfo: curTaskUiInfo }, panelClass: ['animate__animated', 'animate__slideInLeft'],
          disableClose: true,
          position: {
            left: "0%"
          },
          maxWidth: "100%",
          maxHeight: "100vh",
          width: "50%",
          height: "100vh"
        });
        const mediumDialogSubscription = this.isMedium.subscribe(size => {
          if (size.matches) {
            this.matDialogRef.updateSize('70vw', '100vh');
          }
        })
        const smallSubscription = this.isSmall.subscribe(size => {
          if (size.matches) {
            this.matDialogRef.updateSize('100vw', '100vh');
          }
        })
        const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
          if (size.matches) {
            this.matDialogRef.updateSize('100vw', '100vh');
          }
        });
        this.matDialogRef.afterClosed().subscribe(respValue => {
          this.commonAgService.curStatus$.subscribe(resp => {
            if (this.minAttrList.taskId == resp.taskId) {
              this.minAttrList.status = resp.status;
              this.setCurrentStatusCodeByStatus();
            }
          });
          mediumDialogSubscription.unsubscribe();
          smallSubscription.unsubscribe();
          smallDialogSubscription.unsubscribe();
        });
      });

  }

  trackChanges(id: any) {
    this.showToolTip = true;
    //
    let elementCreation = document.getElementById('agMinId' + id);
    $('#agMinId' + id).css("border", "5px solid rgba(0,0,0,.12)")
  }

  removeTrackChanges(id: any) {
    $('#agMinId' + id).css("border", "0px")
    this.showToolTip = false
    //this.isTaskAddedOrModified.emit(this.minAttrList);
  }

  //used to update common task status
  overAllTaskStatusUpdate(e: any, event: any) {
    var statusCode: any
    // var taskStatusIcon = JSON.stringify(event.target.innerText)

    // this.taskStatusIcon = event.target.innerText;
    this.taskStatusList.forEach((data: any) => {
      if (data.code == this.taskStatusCode.value) {
        statusCode = data.codeId
        e.status = statusCode;
      }
    })

    this.commonMinService.updateOverAllTaskStatus(e, this.minAttrList, statusCode);



  }
  //   var taskId = e.taskId;
  //   var meetingId = e.meetingId;
  //   var taskstatus = this.taskStatusCode.value;

  //   var taskStatusUpdateJson = {

  //     "assignTo": this.minAttrList.assignedTo,
  //     "taskCommonStatus": this.taskStatusCode.value,
  //     "taskFinishDate": this.minAttrList.dueDate,
  //     "notes": this.minAttrList.noteDescription,
  //     "meetingId": this.minAttrList.meetingId,
  //     "actionItemId": this.minAttrList.taskId,
  //     "meetingTitle": this.minAttrList.meetingId,
  //     "actionItemTitle": this.minAttrList.taskTitle,
  //     "entityId": this.minAttrList.agendaId,
  //     "newactifonItemOwner": "",
  //     "createdOn": this.minAttrList.createdOn,
  //     "prevLastModifiedOn": "",
  //     "noDirtyCommit": "Y",
  //     "isPrivate": this.minAttrList.isPrivate,
  //     "movingToAgendaId": "",
  //     "fromDragAndDrop": "",
  //     "fromContextMenu": "",
  //     "noteTypeId": this.minAttrList.noteTypeId,
  //     "noteTypeCode": this.minAttrList.noteTypeCode,
  //     "taskId": this.minAttrList.taskId,
  //     "projectId": ""
  //   }
  //   //
  //   //
  //   this.meetingService.updateCommonTaskStatus(taskId, meetingId, taskstatus, taskStatusUpdateJson).subscribe(responsedata => {
  //     //
  //   });

  // }

  //padlock function

  togglePadLock(e: any) {
    // if ((e.target.textContent).trim() == "lock_open") {
    //   this.isPrivate = "Y";
    //   this.padlock = true;

    // }
    // else {
    //   this.isPrivate = "N";
    //   this.padlock = false;
    // }
    this.padlock = !this.padlock;
    this.isPrivate = this.padlock ? 'Y' : 'N';
    var data = {}
    var taskJson = {
      "meetingId": this.minAttrList.meetingId,
      //"minutesId": this.minAttrList.minutesId,
      "taskId": this.minAttrList.taskId,
      "agendaId": this.minAttrList.agendaId,
      "noteTypeId": this.minAttrList.noteTypeId,
      "isPrivate": this.isPrivate,
      "taskEditFrom": "MT",
      "noteTypeCode": this.minAttrList.noteTypeCode,
      "userId": this.globals.userId,
      "deleteFlag": 0,
      "dueDateStr": this.minAttrList.dueDateStr,
      "visitorTimeZone": this.globals.vTimeZone
    }
    var saveUrl = this.commonAgService.getSaveUrl("Y", this.minAttrList.entityType, taskJson);
    this.commonAgService.saveMinutesAttributes(data, taskJson, saveUrl, "Y").then((result: any) => {
      Object.assign(this.minAttrList, result);

      if (this.isPrivate == 'Y') {
        this.editCollabData.elementId = this.minAttrList.taskId;
        this.editCollabData.agElementId = this.minAttrList.agendaId;
        this.editCollabData.meetingId = this.minAttrList.meetingId;
        this.editCollabData.collabType = 'MINPRIVATE'
      } else {
        this.meetingResponse.agendaList.forEach((agElem: any, agIndex: any) => {

          if (agElem.agendaId == this.minAttrList.agendaId) {

            this.editCollabData.agElemPosition = agIndex;

            if (agElem.minutesList != null && agElem.minutesList != undefined) {
              agElem.minutesList.forEach((minElem: any, minIndex: any) => {

                if ((minElem.decisionId != null && minElem.decisionId == this.minAttrList.decisionId)) {

                  this.editCollabData.minElemPosition = minIndex;
                }
              });
            }
          }
        });
        this.editCollabData.elementVal = this.minAttrList;
        this.editCollabData.collabType = 'MIN';
        this.editCollabData.elementId = this.minAttrList.taskId;
        this.editCollabData.meetingId = this.minAttrList.meetingId;
      }

      this.freeFormAgenda.callPushMessageToServer(this.editCollabData, '', '');

    });
  }

  // ===== Quill integration (shared toolbar) =====
  onQuillEditorReady(quill: Quill) {
    try {
      this.quillInst = quill;
      // Register with shared toolbar
      try {
        const selectorId = (this as any).editorConfig?.sharedToolbar?.selectorId || 'quill-shared-toolbar';
        quillSharedToolbar.registerEditor(quill, selectorId);
      } catch {}

      const rootEl = quill.root as HTMLElement;
      const taskIdVal = this.minAttrList.taskId;

      // Ensure legacy attributes required by services
      const ensureLegacyAttrs = () => {
        try {
          rootEl.id = 'agMinId' + taskIdVal;
          rootEl.classList.add('agChildTask','minComCls');
          rootEl.setAttribute('minId', String(taskIdVal));
          rootEl.setAttribute('minid', String(taskIdVal));
          rootEl.setAttribute('taskId', String(taskIdVal));
          rootEl.setAttribute('agId', String(this.minAttrList.agendaId));
          rootEl.setAttribute('agid', String(this.minAttrList.agendaId));
          rootEl.setAttribute('parentAgId', String(this.minAttrList.agendaId));
          rootEl.setAttribute('entityType', this.minAttrList?.entityType || 'AI');
          rootEl.setAttribute('isPrivate', this.isPrivate ?? 'N');
          rootEl.setAttribute('isprivate', this.isPrivate ?? 'N');
          // Seed existingownerids for @mention duplicate filtering ("197,198,")
          try {
            const owners = (this.minAttrList?.actionItemOwner || []) as Array<any>;
            const ids = owners.map(o => (o && (o.fkSecUserOwner || o.userId) ? String(o.fkSecUserOwner || o.userId) : '')).filter(Boolean);
            const attrVal = ids.length ? ids.join(',') + ',' : '';
            if (attrVal) rootEl.setAttribute('existingownerids', attrVal);
          } catch {}
        } catch {}
      };
      ensureLegacyAttrs();

      // Normalize due-date spans and (re)bind datepicker after content is present
      try {
        this.normalizeDueDateSpans(rootEl);
        // Rebind delegated click if needed
        try { this.commonAgService.noteDecisionDatepicker(null); } catch {}
      } catch {}

      // Guard blur-save while clicking toolbar
      const selectorId = (this as any).editorConfig?.sharedToolbar?.selectorId || 'quill-shared-toolbar';
      const shared = document.querySelector('#' + selectorId) as HTMLElement | null;
      if (shared) {
        shared.style.display = 'block';
        shared.addEventListener('mousedown', () => { this.toolbarInteracting = true; }, true);
        shared.addEventListener('mouseup', () => { setTimeout(() => this.toolbarInteracting = false, 0); }, true);
        shared.addEventListener('click', () => { setTimeout(() => this.toolbarInteracting = false, 0); }, true);
      }

      // Outside click handler: save when clicking outside editor AND toolbar (only after user interaction)
      let outsideClickHandler: ((ev: MouseEvent) => void) | null = null;
      outsideClickHandler = (ev: MouseEvent) => {
        // Only handle for this instance when it is currently active AND user has interacted
        if (!this.isActiveEditor || !this.hasUserInteracted) return;
        
        const t = ev.target as Node;
        const insideEditor = rootEl.contains(t);
        const insideToolbar = shared ? shared.contains(t) : false;
        
        // Check if clicking another editor
        const targetEl = ev.target as HTMLElement;
        const clickedAnotherEditor = targetEl?.closest?.('.ql-editor') && !insideEditor;
        // Check if clicking inside dropdown - CRITICAL: skip if on dropdown
        const insideDropdown = targetEl?.closest?.('.mention-dropdown') != null;
        if (insideDropdown) {
          return;
        }
        
        if (!insideEditor && !insideToolbar) {
          // Deactivate this editor and save
          this.isActiveEditor = false;
          this.showDropdown = false;
          this.mentionList = [];
          this.onQuillBlur();
        }
      };
      document.addEventListener('mousedown', outsideClickHandler, true);

      // Mouseup mapping
      rootEl.addEventListener('mouseup', () => {
        const taskDiv = document.createElement('div');
        taskDiv.setAttribute('taskId', this.minAttrList.taskId);
        this.handleMouseUp(taskDiv as unknown as HTMLDivElement);
      });

      // Click -> bring pointer + reinforce attrs + mark as interacted
      rootEl.addEventListener('click', () => {
        try { this.sideNavService.bringPointer(this.minAttrList.taskId); } catch {}
        ensureLegacyAttrs();
        this.isActiveEditor = true;
        this.hasUserInteracted = true;
        try { this.normalizeDueDateSpans(rootEl); } catch {}
      });

      // Mark this instance active on direct interactions (mousedown/focusin)
      rootEl.addEventListener('mousedown', () => { 
        this.isActiveEditor = true; 
        this.hasUserInteracted = true; 
      }, true);
      
      rootEl.addEventListener('focusin', () => { 
        this.isActiveEditor = true; 
        this.hasUserInteracted = true; 
      }, true);

      // Focus moved to another editor -> simulate destroy and blur/save (only after user interaction)
      // try {
      //   const focusSwitchHandler = (ev: Event) => {
      //     if (!this.isActiveEditor || !this.hasUserInteracted) return;
      //     const t = ev.target as HTMLElement | null;
      //     if (!t) return;
      //     const targetEditor = t.closest('.ql-editor') as HTMLElement | null;
      //     if (targetEditor && targetEditor !== rootEl) {
      //       this.isActiveEditor = false;
      //       try { (this.quillInst as any)?.setSelection?.(null); (this.quillInst as any)?.enable?.(false); } catch {}
      //       this.onQuillBlur();
      //     }
      //   };
      //   document.addEventListener('focusin', focusSwitchHandler, true);
      //   document.addEventListener('mousedown', focusSwitchHandler, true);
      // } catch {}

      // Keyboard helpers (parity with CKEditor)
      const invokeTrackChanges = (keyCode: number) => {
        ensureLegacyAttrs();
        const editableEl = rootEl;
        const syntheticEvent: any = {
          target: editableEl,
          currentTarget: editableEl,
          altKey: true,
          keyCode,
          preventDefault: () => {},
          stopPropagation: () => {},
        };
        this.commonAgService.trackChangesWhileEditing(
          this.minAttrList.taskId,
          this.minAttrList.agendaId,
          syntheticEvent,
          this.minAttrList.entityType,
          'agMinId' + this.minAttrList.taskId
        );
      };

      const invokeAgendaEvent = (code: string) => {
        ensureLegacyAttrs();
        const editableEl = rootEl;
        const syntheticEvent: any = {
          target: editableEl,
          currentTarget: editableEl,
          preventDefault: () => {},
          cancel: () => {}
        };
        this.freeFormAgenda.trackAgendaEventOnClick(syntheticEvent, code);
      };

      rootEl.addEventListener('keydown', (ev: KeyboardEvent) => {
        if (!this.hasUserInteracted) this.hasUserInteracted = true;
        const keyCode = (ev as any).keyCode || ev.which;

        // Generic typing: push to Kafka like notes (exclude Alt shortcuts and Enter slash-handling)
        const isAltShortcut = ev.altKey && (
          keyCode === 78 || // N
          keyCode === 68 || // D
          keyCode === 84 || // T
          keyCode === 49 || keyCode === 97 || // 1
          keyCode === 50 || keyCode === 98 || // 2
          keyCode === 51 || keyCode === 99 || // 3
          keyCode === 71 // G
        );
        if (!isAltShortcut && keyCode !== 13) {
          try {
            ensureLegacyAttrs();
            this.commonAgService.trackChangesWhileEditing(
              this.minAttrList.taskId,
              this.minAttrList.agendaId,
              ev as any,
              this.minAttrList.entityType,
              'agMinId' + this.minAttrList.taskId
            );
          } catch {}
        }

        // Alt+N/D/T
        const isAltN = ev.altKey && keyCode === 78;
        const isAltD = ev.altKey && keyCode === 68;
        const isAltT = ev.altKey && keyCode === 84;
        if (isAltN || isAltD || isAltT) {
          invokeTrackChanges(keyCode);
          ev.preventDefault(); ev.stopPropagation();
          return;
        }

        // Alt+1/2/3
        const isAlt1 = ev.altKey && (keyCode === 49 || keyCode === 97);
        const isAlt2 = ev.altKey && (keyCode === 50 || keyCode === 98);
        const isAlt3 = ev.altKey && (keyCode === 51 || keyCode === 99);
        if (isAlt1 || isAlt2 || isAlt3) {
          invokeTrackChanges(keyCode);
          ev.preventDefault(); ev.stopPropagation();
          return;
        }

        // Alt+G -> new Agenda
        const isAltG = ev.altKey && keyCode === 71;
        if (isAltG) {
          invokeAgendaEvent('AG');
          ev.preventDefault(); ev.stopPropagation();
          return;
        }

        

        // Enter: handle trailing slash tokens: delete token, delegate, then blur-save
        if (keyCode === 13) {
          try {
            const sel = quill.getSelection();
            if (!sel) return;
            const caret = sel.index;
            const MAX = 48;
            const start = Math.max(0, caret - MAX);
            // Window and ignore trailing whitespace visually after caret
            let seg = quill.getText(start, caret - start);
            const trailing = seg.match(/[\s\u00a0]+$/);
            const strip = trailing ? trailing[0].length : 0;
            const effEnd = caret - strip;
            const effLen = effEnd - start;
            if (effLen <= 0) return;
            seg = quill.getText(start, effLen);

            // Find last '/' and build token letters only
            const slash = seg.lastIndexOf('/');
            if (slash < 0) return;
            let token = '/';
            for (let i = slash + 1; i < seg.length && token.length <= 5; i++) {
              const ch = seg[i];
              if (!/[a-z]/i.test(ch)) break;
              token += ch;
            }
            const valid = /^(\/nn|\/dd|\/tt|\/ag|\/sg|\/agl|\/sgl|\/ddl|\/ttl|\/nnl|\/date|\/dur)$/i;
            if (!valid.test(token)) return;

            // Delete only the token from Quill content
            const delLen = token.length + strip;
            quill.deleteText(effEnd - token.length, delLen, 'user');

            // Delegate to legacy handler which will insert proper structures
            const root = quill.root as HTMLElement;
            try {
              root.id = 'agMinId' + String(this.minAttrList.taskId);
              root.classList.add('agChildTask', 'minComCls');
              root.setAttribute('taskId', String(this.minAttrList.taskId || ''));
              root.setAttribute('minId', String(this.minAttrList.taskId || ''));
              root.setAttribute('minid', String(this.minAttrList.taskId || ''));
              root.setAttribute('agId', String(this.minAttrList.agendaId));
              root.setAttribute('agid', String(this.minAttrList.agendaId));
              root.setAttribute('entityType', String(this.minAttrList.entityType || 'AI'));
              const t = token.toLowerCase();
              if (t === '/ag') {
                try { root.removeAttribute('parentAgId'); } catch {}
              } else if (t === '/sg') {
                try { root.setAttribute('parentAgId', String(this.minAttrList.agendaId)); } catch {}
              }
            } catch {}

            const syntheticEvent: any = {
              target: root,
              currentTarget: root,
              preventDefault: () => {},
              cancel: () => {}
            };
            (this.freeFormAgenda as any).trackAgendaEventOnClick(syntheticEvent, token.toLowerCase());

            // Mark interacted and force immediate and delayed blur-save to catch async updates
            try { this.hasUserInteracted = true; } catch {}
            try { setTimeout(() => this.onQuillBlur(), 50); } catch {}
            try { setTimeout(() => this.onQuillBlur(), 300); } catch {}

            ev.preventDefault(); ev.stopPropagation();
            return;
          } catch {}
        }
      });

      // Upload adapter
      try {
        const cfg = (this.commonAgService as any)['agoraConfig']?.getConfig() || (this as any).agoraConfig?.getConfig?.();
        if (cfg) {
          setupQuillUploadAdapter(
            quill,
            cfg.apiBaseUrl,
            cfg.endpoints.attachment,
            this.meetingResponse?.meetingId,
            this.minAttrList.agendaId,
            (_url: string) => { try { setTimeout(() => this.onQuillBlur(), 0); } catch {} }
          );
        }
      } catch {}

    // Arrow Down
    quill.keyboard.addBinding(
      { key: 40 },
      (range: any, context: any) => {
        const isDropdownOpen = this.showDropdown && this.mentionList && this.mentionList.length > 0;
        
        if (!isDropdownOpen) {
          return true;
        }

        this.activeIndex = (this.activeIndex + 1) % this.mentionList.length;
        this.cdr.markForCheck();
        this.scrollActiveItemIntoView();

        return false;
      }
    );

    // Arrow Up
    quill.keyboard.addBinding(
      { key: 38 },
      (range: any, context: any) => {
        const isDropdownOpen = this.showDropdown && this.mentionList && this.mentionList.length > 0;
        
        if (!isDropdownOpen) {
          return true;
        }

        this.activeIndex = (this.activeIndex - 1 + this.mentionList.length) % this.mentionList.length;
        this.cdr.markForCheck();
        this.scrollActiveItemIntoView();

        return false;
      }
    );

  // ============= DIRECT KEYDOWN LISTENER FOR ENTER KEY =============
  // This is BEFORE Quill's keyboard binding to intercept the event early
  rootEl.addEventListener('keydown', (event: KeyboardEvent) => {
    const isEnter = event.keyCode === 13 || event.key === 'Enter';
    const isDropdownOpen = this.showDropdown && this.mentionList && this.mentionList.length > 0;
    
    if (!isEnter) return; // Not Enter key, let it through
    
    if (!isDropdownOpen) {
      return; // Dropdown closed, allow normal Enter (newline)
    }

    // DROPDOWN IS OPEN - BLOCK ENTER AND SELECT ITEM
    event.preventDefault(); // STOP THE EVENT COMPLETELY
    event.stopPropagation();
    
    const user = this.mentionList[this.activeIndex];
    if (user) {
      this.insertAssignedUsers(user);
      this.cdr.markForCheck();
    } else if (this.mentionList.length > 0) {
      this.insertAssignedUsers(this.mentionList[0]);
      this.cdr.markForCheck();
    }
  }, true); // Capture phase - runs BEFORE Quill's handlers

  // Remove the old Quill keyboard binding since we're using direct DOM listener
  // quill.keyboard.addBinding() for Enter is no longer needed
    

    quill.on('text-change', async () => {
      const range = quill.getSelection();
      if (!range) return;
    
      const textBefore = quill.getText(0, range.index);
      const match = textBefore.match(/@([\w\s]*)$/);

      if (match) {
        const queryText = match[1] || '';  // important

        this.mentionIndex = range.index - match[0].length;
        this.activeEditor = quill;

        const editableEl = quill.root as HTMLElement;
        const users = await this.getMentionUsers(editableEl);

        // 👇 ALWAYS show full list when only @
        if (queryText.length === 0) {
          this.mentionList = users;
        } else {
          this.mentionList = users.filter((u:any) =>
            u.name.toLowerCase().includes(queryText.toLowerCase())
          );
        }

        this.showDropdown = this.mentionList.length > 0;
        
        // 👇 Reset activeIndex to 0 and scroll to top when dropdown first appears
        if (this.showDropdown) {
          this.activeIndex = 0;
          
          // 👇 Calculate responsive dropdown position with proper offset
          try {
            const bounds = quill.getBounds(range.index) || { top: 0, left: 0, height: 0 };
            const dropdownHeight = 300; // Expected dropdown height (adjust if needed)
            const viewportHeight = window.innerHeight;
            const spaceBelow = viewportHeight - (bounds.top + bounds.height);
            const DROPDOWN_OFFSET = 25; // Offset to show @ and search text
            const HORIZONTAL_OFFSET = 10; // Slight horizontal adjustment
            
            let top: number;
            if (spaceBelow > dropdownHeight) {
              // Enough space below - position dropdown below the caret with offset
              top = bounds.top + bounds.height + DROPDOWN_OFFSET;
            } else {
              // Not enough space below - position dropdown above the caret with offset
              top = bounds.top - dropdownHeight - DROPDOWN_OFFSET;
            }
            
            this.dropdownPosition = {
              top: Math.max(0, top),
              left: Math.max(0, bounds.left + HORIZONTAL_OFFSET)
            };
          } catch (err) {
            this.dropdownPosition = { top: 0, left: 0 };
          }
          
          // Trigger change detection for OnPush strategy
          this.cdr.markForCheck();
          // Ensure first item is visible after dropdown renders
          setTimeout(() => this.scrollActiveItemIntoView(), 0);
        }

      } else {
        this.showDropdown = false;
        this.mentionList = [];
        this.activeIndex = 0;
        // Trigger change detection to hide dropdown
        this.cdr.markForCheck();
      }

    });
    } catch {}
    
  }

  onQuillSelectionChanged(e: any) {
    // DO NOT use selection-change for blur - it fires on load and causes unwanted saves
    // Blur is handled by outside click handler only
  }

  onQuillFocus() {
    try { 
      this.isActiveEditor = true; 
      this.hasUserInteracted = true; 
      this.showToolTip = true; 
    } catch {}
  }

  onQuillBlur() {
    try {
      // Close mention dropdown on blur
      this.showDropdown = false;
      this.mentionList = [];
      
      // Only save if user has actually interacted with this editor
      if (!this.hasUserInteracted) return;
      
      // Guard against toolbar interactions and duplicate saves
      if (this.toolbarInteracting || this.blurSavingGuard) return;
      
      this.blurSavingGuard = true;
      const taskIdVal = this.minAttrList.taskId;
      const host = document.getElementById('agMinId' + taskIdVal) as HTMLElement | null;
      const html = host ? host.innerHTML : (this.minAttrList?.noteDescription || '');
      // Update local model so subsequent re-inits show latest content immediately
      try {
        this.minAttrList.taskTitle = html || '';
        this.lastSavedHtml = this.minAttrList.taskTitle;
        // Also update meetingResponse tree (agenda -> minutes -> this task)
        const agList = (this.meetingResponse && Array.isArray(this.meetingResponse.agendaList)) ? this.meetingResponse.agendaList : [];
        for (const ag of agList) {
          if (ag && Array.isArray(ag.minutesList)) {
            const min = ag.minutesList.find((m: any) => (m && (m.taskId === taskIdVal)));
            if (min) {
              try { min.taskTitle = this.minAttrList.taskTitle; } catch {}
              break;
            }
          }
        }
      } catch {}
      const legacy = document.createElement('div');
      legacy.id = 'agMinId' + taskIdVal;
      legacy.classList.add('agChildTask','minComCls');
      legacy.setAttribute('minId', String(taskIdVal));
      legacy.setAttribute('minid', String(taskIdVal));
      legacy.setAttribute('taskId', String(taskIdVal));
      legacy.setAttribute('agId', String(this.minAttrList.agendaId));
      legacy.setAttribute('agid', String(this.minAttrList.agendaId));
      legacy.setAttribute('parentAgId', String(this.minAttrList.agendaId));
      legacy.setAttribute('entityType', this.minAttrList?.entityType || 'AI');
      legacy.innerHTML = html || '';
      const fakeEvent: any = { target: legacy, currentTarget: legacy, preventDefault: () => {}, stopPropagation: () => {} };
      this.commonMinService.triggerSaveMinutes(legacy, fakeEvent);
    } catch {}
    finally { setTimeout(() => { this.blurSavingGuard = false; }, 250); }
  }

  toggleResPadLock(e: any) {

    // if ((e.target.textContent).trim() == "lock_open private" || (e.target.textContent).trim() == "lock_open") {
    //   this.isPrivate = "Y";
    //   this.padlock = true;

    // }
    // else {
    //   this.isPrivate = "N";
    //   this.padlock = false;
    // }
    this.padlock = !this.padlock;
    this.isPrivate = this.padlock ? 'Y' : 'N';
    var data = {}
    var taskJson = {
      "meetingId": this.minAttrList.meetingId,
      //"minutesId": this.minAttrList.minutesId,
      "taskId": this.minAttrList.taskId,
      "agendaId": this.minAttrList.agendaId,
      "noteTypeId": this.minAttrList.noteTypeId,
      "isPrivate": this.isPrivate,
      "taskEditFrom": "MT",
      "noteTypeCode": this.minAttrList.noteTypeCode,
      "userId": this.globals.userId,
      "deleteFlag": 0,
      "dueDateStr": this.minAttrList.dueDateStr,
      "visitorTimeZone": this.globals.vTimeZone
    }
    var saveUrl = this.commonAgService.getSaveUrl("Y", this.minAttrList.entityType, taskJson);
    this.commonAgService.saveMinutesAttributes(data, taskJson, saveUrl, "Y").then((result: any) => {
      if (this.isPrivate == 'Y') {
        this.editCollabData.elementId = this.minAttrList.taskId;
        this.editCollabData.agElementId = this.minAttrList.agendaId;
        this.editCollabData.meetingId = this.minAttrList.meetingId;
        this.editCollabData.collabType = 'MINPRIVATE'
      } else {
        this.meetingResponse.agendaList.forEach((agElem: any, agIndex: any) => {

          if (agElem.agendaId == this.minAttrList.agendaId) {

            this.editCollabData.agElemPosition = agIndex;

            if (agElem.minutesList != null && agElem.minutesList != undefined) {
              agElem.minutesList.forEach((minElem: any, minIndex: any) => {

                if ((minElem.decisionId != null && minElem.decisionId == this.minAttrList.decisionId)) {

                  this.editCollabData.minElemPosition = minIndex;
                }
              });
            }
          }
        });
        this.editCollabData.elementVal = this.minAttrList;
        this.editCollabData.collabType = 'MIN';
        this.editCollabData.elementId = this.minAttrList.taskId;
        this.editCollabData.meetingId = this.minAttrList.meetingId;
      }

      this.freeFormAgenda.callPushMessageToServer(this.editCollabData, '', '');

    });
  }

  //attachment dialog

  openConfidentialDialog(e: any, m: any) {

    let attchDialog = this.dialog.open(AttachmentDialogComponent, {
      data: { e, m, "data": this.contentEditableBoolmin, "disaleAttachmentFileIcon": this.disaleAttachmentFileIcon },
      panelClass: ['animate__animated', 'animate__slideInLeft'],
      disableClose: true,
      position: {
        left: "0%"
      },
      maxWidth: "100%",
      maxHeight: "100vh",
      width: "50%",
      height: "100vh"
    })
    const mediumDialogSubscription = this.isMedium.subscribe(size => {
      if (size.matches) {
        attchDialog.updateSize('70vw', '100vh');
      }
    })
    const smallSubscription = this.isSmall.subscribe(size => {
      if (size.matches) {
        attchDialog.updateSize('100vw', '100vh');
      }
    })
    const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
      if (size.matches) {
        attchDialog.updateSize('100vw', '100vh');
      }
    });
    attchDialog.afterClosed().subscribe((response: any) => {
      mediumDialogSubscription.unsubscribe()
      smallSubscription.unsubscribe()
      smallDialogSubscription.unsubscribe()
      this.meetingService.fetchTaskInfo(e._id).subscribe((data: any) => {

        if (data != undefined) {
          var minAttrList = this.minAttrList;
          if (minAttrList != null) {
            this.minAttrList.attachmentTotalCnt = data.body.attachmentTotalCnt
            this.commonAgService.pushAttachmentCount(this.minAttrList, data.body.attachmentTotalCnt, 'AI');
          }
        }
      });
    });
    //
  }

  //agenda link dialog

  addNewLink(entityId: any, meetingId: any) {
    let linkDialog = this.dialog.open(AddLinkDialogComponent, {
      data: { entityId, meetingId, "entityType": "AI", "attachmentMode": "LI", "data": this.contentEditableBoolmin, "disaleAttachmentFileIcon": this.disaleAttachmentFileIcon },
      panelClass: ['animate__animated', 'animate__slideInLeft'],
      disableClose: true,
      position: {
        left: "0%"
      },
      maxWidth: "100%",
      maxHeight: "100vh",
      width: "50%",
      height: "100vh"
    })
    const mediumDialogSubscription = this.isMedium.subscribe(size => {
      if (size.matches) {
        linkDialog.updateSize('70vw', '100vh');
      }
    })
    const smallSubscription = this.isSmall.subscribe(size => {
      if (size.matches) {
        linkDialog.updateSize('100vw', '100vh');
      }
    })
    const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
      if (size.matches) {
        linkDialog.updateSize('100vw', '100vh');
      }
    });
    linkDialog.afterClosed().subscribe((response: any) => {
      mediumDialogSubscription.unsubscribe()
      smallSubscription.unsubscribe()
      smallDialogSubscription.unsubscribe()
      this.meetingService.fetchTaskInfo(entityId).subscribe((data: any) => {

        if (data != undefined) {
          var minAttrList = this.minAttrList;
          if (minAttrList != null) {
            this.minAttrList.attachmentTotalCnt = data.body.attachmentTotalCnt
            this.commonAgService.pushAttachmentCount(this.minAttrList, data.body.attachmentTotalCnt, 'AI');
          }
        }
      });
    });
  }
  getAttachCount(e: any) {

    this.meetingService.fetchTaskInfo(e.taskId).subscribe((data: any) => {
      this.agendaAttachResp = data.body;

      this.attachCount = false;
    });
  }

  ngOnChanges(event: any) {

    this.setCurrentStatusCodeByStatus();
  }

  // ngOnChanges(event : any){
  //   
  //   let agMinId = (<HTMLElement>document.getElementById('agMinId'+event.collbElementId.currentValue));

  //   // (<HTMLElement>document.getElementById('agMinId'+event.collbElementId.currentValue)).addEventListener('keyup', (e : any) => {
  //   
  //   
  //   // })


  //   if(this.minAttrList.rowStatus != undefined || this.minAttrList.rowStatus != null){
  //     let noteIdAccess = (<HTMLElement>document.getElementById('agMinId'+event.collbElementId.currentValue))
  //       noteIdAccess.title = this.minAttrList.rowStatus
  //   }
  //   // let noteId = document.getElementById(event)
  //   
  //   
  //   

  //   function getCaretCoordinates() {
  //     let x = 0,
  //       y = 0;
  //     const isSupported = typeof window.getSelection !== "undefined";
  //     if (isSupported) {
  //       const selection = window.getSelection();
  //       if (selection!.rangeCount !== 0) {
  //         const range = selection!.getRangeAt(0).cloneRange();
  //         range.collapse(true);
  //         const rect = range.getClientRects()[0];
  //         if (rect) {
  //           x = rect.left;
  //           y = rect.top;
  //         }
  //       }
  //     }
  //     return { x, y };
  //   }

  //   const toggleTooltip = (event: { target: any; }, contenteditable: { contains: (arg0: any) => any; }) => {

  //     const tooltip = document.getElementById("tooltip");

  //     if (contenteditable.contains(event.target)) {
  //       // window.alert("called")
  //       const { x, y } = getCaretCoordinates();

  //       tooltip!.setAttribute("aria-hidden", "false");
  //       // if(this.deviceXs == true || this.deviceSm == true || this.deviceMd == true){
  //       //   window.alert("style triggered")
  //       //   tooltip!.setAttribute(
  //       //     "style",
  //       //     `display: inline-block;
  //       //     position : absolute; 
  //       //     left: ${x - 32}px;
  //       //     top: ${y - 1100}px`
  //       //   );  
  //       // }
  //       // else{
  //         tooltip!.setAttribute(
  //           "style",
  //           `display: inline-block;
  //           position : absolute; 
  //           left: ${x - 132}px;
  //           top: ${y - 390}px`
  //         );
  //       // }
  //     } 
  //     else {
  //       tooltip!.setAttribute("aria-hidden", "true");
  //       tooltip!.setAttribute("style", "display: none;");
  //     }
  //   }

  //   window.addEventListener("click", (e) => toggleTooltip(e, agMinId));
  //   window.addEventListener("focus", (e) => toggleTooltip(e, agMinId))
  //   window.addEventListener("keyup", (e) => toggleTooltip(e, agMinId));

  // }

  createEmptyAgenda(event: any) {

    var roleFlag = this.permissionService.checkRoleRightsWithAlert(this.utility.featureList.AGENDA, this.utility.permissionType.ADD);

    if (!roleFlag) {
      return
    }
    var newAg = 'AG'
    this.commonAgService.trackAgendaEventOnClick(event, newAg);

  }

  createEmptyNote(event: any) {

    var roleFlag = this.permissionService.checkRoleRightsWithAlert(this.utility.featureList.NOTES, this.utility.permissionType.ADD);

    if (!roleFlag) {
      return
    }
    var entityType = "/nn";
    this.commonAgService.trackAgendaEventOnClick(event, entityType);

  }

  createEmptyTask(event: any) {
    var roleFlag = this.permissionService.checkRoleRightsWithAlert(this.utility.featureList.TASK, this.utility.permissionType.ADD);

    if (!roleFlag) {
      return
    }
    var entityType = "/tt";
    this.commonAgService.trackAgendaEventOnClick(event, entityType);

  }

  createEmptyDecision(event: any) {

    var roleFlag = this.permissionService.checkRoleRightsWithAlert(this.utility.featureList.NOTES, this.utility.permissionType.ADD);

    if (!roleFlag) {
      return
    }
    var entityType = "/dd";
    this.commonAgService.trackAgendaEventOnClick(event, entityType);

  }

  //add to tuleap dialog
  addToTuleapDialog(minAttrList: any, meetRes: any) {
    if ((minAttrList.assignedTo != "" && minAttrList.assignedTo != "[]" && minAttrList.dueDateStr != "" && minAttrList.dueDateStr != null) || (minAttrList.actionItemOwner.length != 0 && minAttrList.dueDateStr != "" && minAttrList.dueDateStr != null)) {
      //var formattedMeetingDate = this.datepipe.transform(this.meetingResponse.meetingDate,'YYYY-MM-dd');
      let dateParts = this.meetingResponse.meetingDate.split(' ');  // Split by space to separate date and time
      let date = dateParts[0].split('/');
      var formattedMeetingDate = `20${date[2]}-${date[1]}-${date[0]}`;
      const tuleapDialog = this.dialog.open(TuleapDialogComponent, {
        data: { taskData: minAttrList, tuleapMeetingTitle: this.meetingResponse.meetingTitle, tuleapMeetingDate: formattedMeetingDate, tuleapMeetingId: this.meetingResponse.meetingId },
        panelClass: ['animate__animated', 'animate__slideInLeft'],
        disableClose: true,
        position: {
          left: "0%"
        },
        maxWidth: "100%",
        maxHeight: "100vh",
        width: "50%",
        height: "100vh"
      })
      const mediumDialogSubscription = this.isMedium.subscribe(size => {
        if (size.matches) {
          tuleapDialog.updateSize('70vw', '100vh');
        }
      })
      const smallSubscription = this.isSmall.subscribe(size => {
        if (size.matches) {
          tuleapDialog.updateSize('100vw', '100vh');
        }
      })
      const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
        if (size.matches) {
          tuleapDialog.updateSize('100vw', '100vh');
        }
      });
      tuleapDialog.afterClosed().subscribe((response: any) => {
        if (response != null && response.body.tuleapId != null) {
          this.enableTuleapTaskAdded = false;
          this.disabelTuleapBtn = true;
          this.showTuleapIcon = false;
        } else {
          this.disabelTuleapBtn = false;
          this.enableTuleapTaskAdded = true;
        }
      });
    } else {

      this.sideNavService.alertAddToTuleapTask('show')

    }
  }



  //tuleap trackers update method to update tuleap tasks
  tuleapTrackersUpdate(taskDetails: any) {
    var trackersDetails: any;
    this.loginService.getTrackersDetails(taskDetails.tuleapId).subscribe(data => { //API call to get trackers details
      trackersDetails = data.body;
    });

    var reqJson = {

      "assignedTo": "",
      "client": trackersDetails.client,
      "plannedDuration": "",
      "plannedEndDate": "",
      "plannedStartDate": "",
      "product": trackersDetails.product,
      "projectId": trackersDetails.projectId,
      "status": "",
      "taskId": "",
      "taskTitle": "",
      "tuleapId": "", //,mandatory to send while updating tuleap task
      "userId": ""

    }
    this.loginService.saveTuleapTask(reqJson).subscribe(data => {
      if (data.body.tuleapId != null) {
        this.notifier.notify("success", "Task added to Tuleap successfully");
      }
    });

  }
  history(entityId: any, modifiedName: any) {
    var entityType = "AI";
    this.historyDialogService.openHistoryDialog(entityId, entityType, modifiedName, this.isMedium, this.isSmall, this.isExtraSmall);
  }
  blur(target: any, event: any) {
    var selectTextAsTask = (event.altKey && (event.keyCode == 78 || event.keyCode == 68 || event.keyCode == 84));//(ALT+N)
    if (selectTextAsTask) {
      this.commonMinService.triggerSaveMinutes(target, event);
    }
  }
  // openLinkToNoteDialog(meetingId?: number): void {
  //   const id = meetingId || this.meetingResponse?.meetingId;
  //   const decryptKey = this.minAttrList?.decryptKey;

  //   if (!id) {
  //     console.error('Meeting ID is not defined');
  //     return;
  //   }

  //   if (!this.minAttrList?.taskId) {
  //     console.error('Task ID is not defined');
  //     return;
  //   }

  //   const openDialogWithNormalizedData = (taskRes: any, notesDetails: any[], agendas: any[]) => {
  //     taskRes.linkedNoteIds = Array.isArray(taskRes.linkedNoteIds) ? taskRes.linkedNoteIds : [];

  //     // Combine agendas with notes
  //     const meetingDataBasedOnAgendas = agendas.map(agenda => {
  //       const relatedNotes = notesDetails.filter(note => note.agendaId === agenda.id);
  //       return {
  //         ...agenda,
  //         notes: relatedNotes
  //       };
  //     });

  //     this.dialog.open(LinkTasktonoteDialogComponent, {
  //       data: {
  //         meetingRes: meetingDataBasedOnAgendas, // pass combined agendas + notes
  //         taskRes,
  //         LinkedNoteIds: taskRes.linkedNoteIds
  //       },
  //       panelClass: ['animate__animated', 'animate__slideInLeft'],
  //       disableClose: false,
  //       position: { left: '0%' },
  //       maxWidth: '100vw',
  //       maxHeight: '100vh',
  //       width: '50%',
  //       height: '100vh',
  //       autoFocus: false
  //     });
  //   };

  //   // Step 1: fetch main task/notes for the meeting
  //   this.meetingService.fetchNotesByMeetingId(id, decryptKey).subscribe({
  //     next: (taskData: any) => {
  //       const mergedTaskRes = { ...this.minAttrList, ...taskData };

  //       // Step 2: fetch task info to get linkedNoteIds
  //       this.meetingService.fetchTaskInfo(this.minAttrList.taskId).subscribe({
  //         next: (taskRes: any) => {
  //           const linkedNoteIds: number[] = Array.isArray(taskRes.body?.linkedNoteIds)
  //             ? taskRes.body.linkedNoteIds
  //             : [];

  //           // Step 3: prepare observables for each linked note detail
  //           const noteRequests = linkedNoteIds.length > 0
  //             ? linkedNoteIds.map(noteId => this.meetingService.fetchNotesByMeetingId(noteId, decryptKey))
  //             : [];

  //           // Step 4: fetch agendas for the meeting
  //           const agendaRequest = this.meetingService.fetchAgendaListByMeeting(id);

  //           // Step 5: combine all observables
  //           forkJoin({
  //             notesDetails: noteRequests.length > 0 ? forkJoin(noteRequests) : of([]),
  //             agendas: agendaRequest
  //           }).subscribe({
  //             next: ({ notesDetails, agendas }) => {
  //               openDialogWithNormalizedData(mergedTaskRes, notesDetails.map(res => res), agendas);
  //             },
  //             error: (err) => console.error('Error fetching linked notes or agendas:', err)
  //           });
  //         },
  //         error: (err) => {
  //           console.error('Error fetching task info:', err);
  //           openDialogWithNormalizedData(mergedTaskRes, [], []);
  //         }
  //       });
  //     },
  //     error: (err: any) => {
  //       console.error('Error fetching main notes data:', err);
  //       openDialogWithNormalizedData(this.minAttrList, [], []);
  //     }
  //   });
  // }


  // Task info API call
  taskInfo: any
  agendasinfoe: any;
  openLinkToNoteDialog(meetingId?: number): void {
    const id = meetingId || this.meetingResponse?.meetingId;
    const decryptKey = this.minAttrList?.decryptKey;


    if (!id || !this.minAttrList?.taskId) {
      console.error('Meeting ID or Task ID is not defined');
      return;
    }

    // Step 1: Fetch task info first
    this.meetingService.fetchTaskInfo(this.minAttrList.taskId).subscribe({
      next: (taskRes: any) => {
        const taskInfo = taskRes.body || {};

        this.taskInfo = taskInfo;

        // Step 2: Fetch notes for the meeting
        this.meetingService.fetchNotesByMeetingId(id, decryptKey).subscribe({
          next: (notes: any[]) => {

            this.toLinkingNotes = notes || [];

            // Step 3: Fetch agendas
            this.meetingService.fetchAgendaListByMeeting(id).subscribe({
              next: (agendas: any[]) => {

                this.agendasinfoe = agendas || [];

                // Map notes to agendas
                const agendasWithNotes = this.agendasinfoe.map((agenda: { agendaId: any; }) => ({
                  ...agenda,
                  notes: this.toLinkingNotes.filter((note: { agendaId: any; }) => note.agendaId === agenda.agendaId)
                }));

                // Open dialog
                // this.dialog.open(LinkTasktonoteDialogComponent, {
                //   data: {
                //     meetingRes: this.toLinkingNotes,
                //     agendas: this.agendasinfoe,
                //     agendasWithNotes,
                //     taskRes: this.taskInfo,
                //     linkedNoteIds: Array.isArray(taskInfo.linkedNoteIds)
                //       ? taskInfo.linkedNoteIds
                //       : []
                //   },
                //   panelClass: ['animate__animated', 'animate__slideInLeft'],
                //   disableClose: false,
                //   position: { left: '0%' },
                //   maxWidth: '100vw',
                //   maxHeight: '100vh',
                //   width: '50%',
                //   height: '100vh',
                //   autoFocus: false
                // });
                this.dialog.open(LinkNotetotaskDialogComponent, {
                  data: {
                    meetingRes: this.toLinkingNotes,
                    agendas: this.agendasinfoe,
                    agendasWithNotes,
                    type: "TASK",
                    meetingTitle: this.meetingResponse.meetingTitle,
                    noteRes: this.taskInfo,
                    linkedNoteIds: Array.isArray(this.taskInfo.linkedTaskIds)
                      ? this.taskInfo.linkedTaskIds
                      : []
                  },
                  panelClass: ['animate__animated', 'animate__slideInLeft'],
                  disableClose: false,
                  position: { left: '0%' },
                  maxWidth: '100vw',
                  maxHeight: '100vh',
                  width: '50%',
                  height: '100vh',
                  autoFocus: false
                });
              },
              error: (err: any) => console.error('Error fetching agendas:', err)
            });
          },
          error: (err: any) => console.error('Error fetching task:', err)
        });
      },
      error: (err: any) => console.error('Error fetching notes:', err)
    });
  }

  insertOwnerLabelBeforeFirstMention(editor: any) {
    editor.model.change((writer: any) => {
      const root = editor.model.document.getRoot();
  
      for (const block of root.getChildren()) {
        if (!block.is('element', 'paragraph')) continue;
  
        for (const child of block.getChildren()) {
          //first mention text node
          if (child.is('$text') && child.hasAttribute('mention')) {
            const insertPos = writer.createPositionBefore(child);
  
            const viewFragment = editor.data.processor.toView(
              '<span class="assignCls">Owner(s):&nbsp;</span>'
            );
  
            const modelFragment = editor.data.toModel(viewFragment);
  
            editor.model.insertContent(modelFragment, insertPos);
            return; 
          }
        }
      }
    });
  }

  onMentionItemClick(user: any, event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.insertAssignedUsers(user);
  }

  insertAssignedUsers(user: any) {
    try {
      
      const quill: any = this.activeEditor;
      if (!quill) {
        return;
      }

      const range = quill.getSelection(true);
      if (!range) {
        return;
      }

      let index = range.index;

      // Store the mention position BEFORE deletion
      const mentionPositionIndex = this.mentionIndex ?? index;
      
      // Get the root element and check for existing owner label BEFORE deleting
      const rootEl = quill.root as HTMLElement;
      const html = rootEl.innerHTML || '';
      
      // Check if TaskOwnerLabelBlot label already exists (look for assignCls)
      const labelExists = html.includes('assignCls');

      // Remove @query text (replace @ with mention)
      if (this.mentionIndex != null) {
        quill.deleteText(
          this.mentionIndex,
          index - this.mentionIndex
        );
        index = this.mentionIndex;
      }

      let finalInsertionIndex = index;

      // If label doesn't exist, ADD IT at the mention position (where @ was)
      if (!labelExists) {
        
        // Insert TaskOwnerLabelBlot at the @ position
        (quill as any).insertEmbed(mentionPositionIndex, 'taskownerlabel', {});
        
        // Add a space after the label
        quill.insertText(mentionPositionIndex + 1, ' ');
        
        // Mention insertion index = after label + space
        finalInsertionIndex = mentionPositionIndex + 2;
      } else {
        finalInsertionIndex = index;
      }

      // Now add the user mention - this replaces the @ with the selected user
      // Check if this is the first mention (no mention spans exist yet)
      const updatedHtml = rootEl.innerHTML || '';
      const mentionSpansExist = updatedHtml.includes('class="atwho-inserted"');
      
      // For subsequent users, prepend comma to the name
      const mentionName = mentionSpansExist ? `, ${user.name}` : user.name;
      const value = {
        userId: user.id,
        name: mentionName,
        email: user.email,
        isexternal: user.isexternal
      };
      
      
      // Insert the mention blot (replaces the @ symbol)
      (quill as any).insertEmbed(finalInsertionIndex, 'atwhomention', value);
      
      // Add space after mention
      quill.insertText(finalInsertionIndex + 1, ' ');
      
      // Move cursor to after the mention and space
      quill.setSelection(finalInsertionIndex + 2, 0, 'user');

      // Update existingownerids attribute to prevent duplicates
      try {
        const prev = rootEl.getAttribute('existingownerids') || '';
        const existingIds = prev.split(',').filter(Boolean);
        if (!existingIds.includes(user.id)) {
          rootEl.setAttribute('existingownerids', (prev + user.id + ',').replace(/,,+/g, ','));
        }
      } catch {}


      /* CLOSE DROPDOWN */
      this.showDropdown = false;
      this.mentionList = [];
      this.activeIndex = 0;
      
      // Trigger change detection for OnPush strategy
      this.cdr.markForCheck();
      
    } catch (err) {
      console.error('Error inserting mention:', err);
    }
  }
  

  async getMentionUsers(elem: HTMLElement) {
    const result: any = await this.attendeeService.fetchUserListSource("");
  
    // Read attribute (check both lowercase and camelCase for compatibility)
    const existingOwnerIdsAttr =
      elem.getAttribute('existingownerids') || elem.getAttribute('existingOwnerIds') || '';
  
    const existingOwnerIds = new Set(
      existingOwnerIdsAttr
        .split(',')
        .map(id => id.trim())
        .filter(id => id)
    );
    
  
    // Filter out already selected participants and map to display format
    const filteredUsers = result
      .filter((u: any) =>
        !existingOwnerIds.has(u.userId.toString())
      )
      .map((u: any) => {
        const name = u.userLastname
          ? `${u.userFirstname} ${u.userLastname}`
          : u.userFirstname;
  
        return {
          id: u.userId.toString(),
          name: name,
          email: u.userEmail,
          isexternal: u.isexternal || u.IsExternal || 0
        };
      });
    
    return filteredUsers;
  }

  // Scroll active mention item into view when navigating with arrow keys
  scrollActiveItemIntoView() {
    try {
      // Use setTimeout to ensure DOM is updated with active class
      setTimeout(() => {
        const activeItem = document.querySelector('.mention-item.active');
        if (activeItem && activeItem.parentElement) {
          const dropdownContainer = activeItem.parentElement;
          const itemTop = (activeItem as HTMLElement).offsetTop;
          const itemHeight = (activeItem as HTMLElement).offsetHeight;
          const containerTop = dropdownContainer.scrollTop;
          const containerHeight = dropdownContainer.clientHeight;
          
          // Scroll if item is below visible area
          if (itemTop + itemHeight > containerTop + containerHeight) {
            dropdownContainer.scrollTop = itemTop + itemHeight - containerHeight;
          }
          // Scroll if item is above visible area
          else if (itemTop < containerTop) {
            dropdownContainer.scrollTop = itemTop;
          }
        }
      }, 0);
    } catch {}
  }

}


